import { Typography } from '../../../../../core/components/molecules/Typography';
import { MaterialTypes } from '../../../models/Material.model';
import { LessonCardItem } from '../LessonCardItem';

import { MaterialCardItem } from '../MaterialCardItem';

interface CourseContentCardProps {
  content: any;
  selected?: boolean;
  onClick: () => void;
  onClickDone: () => void;
}

function CourseContentCard({
  content,
  selected,
  onClick,
  onClickDone,
}: CourseContentCardProps) {
  const materialType = content.type as MaterialTypes;

  if (materialType === 'Label') {
    return (
      <Typography
        type='titleSection'
        size='h5'
        key={`lbl-content-${content._contentId}`}
      >
        {content.value}
      </Typography>
    );
  }

  if (materialType === 'Lesson') {
    return (
      <LessonCardItem
        content={content}
        selected={selected}
        onClick={onClick}
        onClickDone={onClickDone}
      />
    );
  }

  return (
    <MaterialCardItem
      content={content}
      selected={selected}
      onClick={onClick}
      onClickDone={onClickDone}
    />
  );
}

export { CourseContentCard };
